module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.e406133e.woff";